import * as actionTypes from './thesaurusActionTypes';
import piction from '../utils/piction';
import { SESSION_EXPIRED_MESSAGE } from '../constants/sessionStateTypes';
import { sessionExpired } from './session';
import appConfig from '../appConfig';
import _ from 'lodash';
import * as categoriesActionTypes from "./categoriesActionTypes";

export const cancelAllRequests = () => ({
  type: actionTypes.THES_CANCEL_ALL_REQUESTS,
});

export const cancelCreateRequest = (workspaceName, workspaceParentID = '0') => ({
  type: actionTypes.THES_CANCEL_CREATE_REQUEST,
  workspaceName,
  workspaceParentID,
});

export const retrieveTermsRequest = requestPromise => ({
  type: actionTypes.TERM_RETRIEVE_REQUEST,
  requestPromise,
});

export const retrieveTermsSuccess = (termsList, parentID) => ({
  type: actionTypes.TERM_RETRIEVE_SUCCESS,
  termsList,
  parentID,
});

export const retrieveTermsFailure = err => ({
  type: actionTypes.TERM_RETRIEVE_FAILURE,
  err,
});

export const retrieveTerms = (parentID = '') =>
  function retrieveTermsDispatch(dispatch) {
    const options = {
      OPTION: 'QUERY_CHILDREN',
      THES_ID: appConfig.thesaurus.id,
      PARENT: parentID,
    };

    const promise = piction.request('THESAURUS_SEARCH', options)
      .then((res) => {
        let terms = [];
        if (res.a.TERM && _.isArray(res.a.TERM)) {
          terms = _.map(res.a.TERM, term => ({ i: term.$.ID, n: term._, ch: 'TRUE', ct: [] }));
        }
        dispatch(retrieveTermsSuccess(terms, parentID));
        return res;
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(err));
        } else {
          dispatch(retrieveTermsFailure(err));
        }
        return err;
      });

    dispatch(retrieveTermsRequest(promise));
    return promise;
  };

export const clearPanelTreeList = categoryID => ({
  type: actionTypes.THES_LIST_CLEAR,
  categoryID,
});

export const createWorkspaceRequest = (
  workspaceName, workspaceParentID, requestPromise
) => ({
  type: actionTypes.TERM_CREATE_REQUEST,
  workspaceName,
  workspaceParentID,
  requestPromise,
});

export const createWorkspaceSuccess = (workspaceID, workspaceName, workspaceParentID) => ({
  type: actionTypes.TERM_CREATE_SUCCESS,
  workspaceID,
  workspaceName,
  workspaceParentID,
});

export const createWorkspaceFailure = (workspaceName, workspaceParentID, err) => ({
  type: actionTypes.TERM_CREATE_FAILURE,
  workspaceName,
  workspaceParentID,
  err,
});

export const createTerm = (workspaceName, workspaceParentID) =>
  function createWorkspacesDispatch(dispatch, getState) {
    const store = getState().thesaurus;

    const foundRequestIndex = store.get('createRequests').findKey(createRequest =>
      createRequest.get('workspaceName') === workspaceName &&
      createRequest.get('workspaceParentID') === workspaceParentID
    );

    if (foundRequestIndex !== undefined &&
      !(store.getIn(['createRequests', foundRequestIndex, 'request']) instanceof Error)
    ) {
      return Promise.resolve(new Error('Request with same details already being made'));
    }
    const options = {
      OPTION: 'INSERT',
      THES_ID: appConfig.thesaurus.id,
      NAME: workspaceName,
    };
    if (workspaceParentID) {
      options.RELATED_TERM_ID = workspaceParentID;
      options.RELATIONSHIP = 'BT';
    }
    const promise = piction.request('THESAURUS_TERM', options)
      .then((res) => {
        if (res.a && res.a.RETURN_MESSAGE && res.a.RETURN_MESSAGE[1].includes('Inserted')) {
          dispatch(
            createWorkspaceSuccess(res.a.RETURN_MESSAGE[0], workspaceName, workspaceParentID)
          );
        } else {
          return new Error(res);
        }
        return res;
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(err));
        } else {
          dispatch(createWorkspaceFailure(workspaceName, workspaceParentID, err));
        }
        return err;
      });

    dispatch(
      createWorkspaceRequest(workspaceName, workspaceParentID, null, promise)
    );
    return promise;
  };

export const deleteWorkspaceRequest = (workspaceID, requestPromise) => ({
  type: actionTypes.TERM_DELETE_REQUEST,
  workspaceID,
  requestPromise,
});

export const deleteWorkspaceSuccess = workspaceID => ({
  type: actionTypes.TERM_DELETE_SUCCESS,
  workspaceID,
});

export const deleteWorkspaceFailure = (workspaceID, err) => ({
  type: actionTypes.TERM_DELETE_FAILURE,
  workspaceID,
  err,
});

export const deleteTerm = workspaceID =>
  function deleteWorkspaceDispatch(dispatch) {
    const options = {
      OPTION: 'DELETE_RAW',
      THES_ID: appConfig.thesaurus.id,
      TERM_ID: workspaceID,
    };

    const promise = piction.request('THESAURUS_TERM', options)
      .then((res) => {
        if (res.a && res.a.RETURN_MESSAGE && res.a.RETURN_MESSAGE[0] === 'Deleted') {
          dispatch(deleteWorkspaceSuccess(workspaceID));
          dispatch(retrieveTerms(workspaceID));
        } else {
          new Error(res);
        }
        return res;
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(err));
        } else {
          dispatch(deleteWorkspaceFailure(workspaceID, err));
        }
        return err;
      });

    dispatch(deleteWorkspaceRequest(workspaceID, promise));
    return promise;
  };

export const editWorkspaceRequest =
  (workspaceID, workspaceName, requestPromise) => ({
    type: actionTypes.TERM_EDIT_REQUEST,
    workspaceID,
    workspaceName,
    requestPromise,
  });

export const editWorkspaceSuccess = (workspaceID, workspaceName) => ({
  type: actionTypes.TERM_EDIT_SUCCESS,
  workspaceID,
  workspaceName,
});

export const editWorkspaceFailure = (workspaceID, err) => ({
  type: actionTypes.TERM_EDIT_FAILURE,
  workspaceID,
  err,
});

export const editTerm = (workspaceID, workspaceName) =>
  function retrieveWorkspacesDispatch(dispatch) {
    const options = {
      OPTION: 'UPDATE',
      THES_ID: appConfig.thesaurus.id,
      TERM_ID: workspaceID,
      NAME: workspaceName,
    };
    const promise = piction.request('THESAURUS_TERM', options)
      .then((res) => {
        dispatch(editWorkspaceSuccess(workspaceID, workspaceName));
        return res;
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(err));
        } else {
          dispatch(editWorkspaceFailure(workspaceID, err));
        }
        return err;
      });

    dispatch(editWorkspaceRequest(workspaceID, workspaceName, promise));
    return promise;
  };

